import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, useAccount } from '@azure/msal-react';
import { loginRequest } from '../auth/msalConfig';
import { AdminNav } from '../components/AdminNav';
import { Link } from 'react-router-dom';

export function Admin() {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] ?? null);

  const signIn  = () => { instance.loginRedirect(loginRequest).catch((e) => console.error('signIn failed', e)); };
  const signOut = () => { instance.logoutRedirect().catch((e) => console.error('signOut failed', e)); };

  const claims = account?.idTokenClaims as Record<string, unknown> | undefined;
  const roles  = Array.isArray(claims?.roles) ? (claims!.roles as string[]) : [];
  const email  = (claims?.email as string | undefined) ?? account?.username ?? '';
  const name   = (claims?.name as string | undefined) ?? '';
  const hasAdmin  = roles.includes('WIC.Conf.Admin');
  const hasReader = roles.includes('WIC.Conf.Reader');

  return (
    <>
      <UnauthenticatedTemplate>
        <section className="card">
          <p className="eyebrow">Admin</p>
          <h2>Sign in to manage rooms and displays</h2>
          <p className="muted" style={{ marginBottom: '1.25rem' }}>
            You'll need <code>WIC.Conf.Admin</code> or <code>WIC.Conf.Reader</code>
            assigned to your account in Entra to see anything beyond this page.
          </p>
          <button onClick={signIn}>Sign in with Microsoft</button>
        </section>
      </UnauthenticatedTemplate>

      <AuthenticatedTemplate>
        <AdminNav />

        <section className="card admin-welcome">
          <p className="eyebrow">Admin</p>
          <h2>{name ? `Welcome, ${name.split(' ')[0]}` : 'Welcome'}</h2>
          <ul className="kv" style={{ marginTop: '1rem' }}>
            <li><span>email</span><code>{email || '(none)'}</code></li>
            <li>
              <span>roles</span>
              <span className="role-chips">
                {roles.length === 0 ? <em className="muted">(none assigned)</em> : null}
                {roles.map((r) => (
                  <span key={r} className={`role-chip${r === 'WIC.Conf.Admin' ? ' role-chip-admin' : ''}`}>{r}</span>
                ))}
              </span>
            </li>
          </ul>
          {roles.length === 0 ? (
            <p className="error" style={{ marginTop: '1rem' }}>
              No <code>WIC.Conf.*</code> role assigned to this account. Open Entra → Enterprise
              applications → WIC Conference Room Scheduling → Users &amp; groups and assign a role,
              then sign out and back in.
            </p>
          ) : null}
          <div style={{ marginTop: '1.25rem' }}>
            <button onClick={signOut}>Sign out</button>
          </div>
        </section>

        {(hasAdmin || hasReader) ? (
          <section className="admin-tiles">
            <Link to="/admin/rooms" className="admin-tile">
              <p className="eyebrow">Configure</p>
              <h3>Rooms</h3>
              <p className="muted">Map rooms to M365 mailboxes; toggle active.</p>
            </Link>
            <Link to="/admin/devices" className="admin-tile">
              <p className="eyebrow">Operate</p>
              <h3>Devices</h3>
              <p className="muted">Assign paired iPads to rooms; send remote actions.</p>
            </Link>
            <Link to="/admin/health" className="admin-tile">
              <p className="eyebrow">Operate</p>
              <h3>Health</h3>
              <p className="muted">Live status of Cosmos, Key Vault, Graph + the kiosk fleet.</p>
            </Link>
          </section>
        ) : null}
      </AuthenticatedTemplate>
    </>
  );
}
